import Router from 'routes';
import routeList from './index';

function AppRouter (opts) {
    var router = Router();
    var api = opts.api;
    var socket = opts.socket;

    routeList.forEach(function (route) {
        var path = route[0];
        var fn = route[1];
        router.addRoute(path, function () {
            var args = Array.prototype.slice.call(arguments);
            if (fn.default) {
                return fn.default.apply(null, [api, socket, opts].concat(args))
            } else {
                return fn.apply(null, [api, socket, opts].concat(args))
            }
        });
    });

    return router;
}

export default AppRouter;
